import styled from 'styled-components';

const journeyIdSkins = {
  pending: {
    bg: 'primary100',
    color: 'primary300',
  },
  in_progress: {
    bg: 'success100',
    color: 'success700',
  },
  cancel: {
    bg: 'error100',
    color: 'error700',
  },
  default: { bg: 'grey200', color: 'grey500' },
};

export default styled.div`
  flex: 1 0 20%;
  display: flex;
  align-items: center;
  background-color: ${({ theme, skin }) =>
    theme.base.colorSchema[journeyIdSkins[skin].bg] || journeyIdSkins.default.bg};
  color: ${({ theme, skin }) =>
    theme.base.colorSchema[journeyIdSkins[skin].color] || journeyIdSkins.default.color};
  justify-content: center;
`;
